export const walletPackages = [
  { id: 'pkg-100', coins: 100, price: 10, bonus: 5 },
  { id: 'pkg-500', coins: 500, price: 50, bonus: 40 },
  { id: 'pkg-1200', coins: 1200, price: 100, bonus: 120 },
  { id: 'pkg-2500', coins: 2500, price: 199, bonus: 350 },
];

export const initialTransactions = [
  { id: 'txn-1', type: 'Win', label: '4P Classic Match', amount: '+700 Coins', time: 'Today • 08:25 PM' },
  { id: 'txn-2', type: 'Recharge', label: 'Razorpay Success', amount: '+500 Coins', time: 'Today • 07:42 PM' },
  { id: 'txn-3', type: 'Entry', label: 'Quick Match Fee', amount: '-100 Coins', time: 'Today • 07:40 PM' },
  { id: 'txn-4', type: 'Bot', label: 'Vs Bot Practice', amount: '+40 Coins', time: 'Yesterday • 11:14 PM' },
];

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function createRazorpayOrder(pkg) {
  await wait(700);
  return {
    orderId: `order_${pkg.id}`,
    packageId: pkg.id,
    amount: pkg.price,
    currency: 'INR',
    status: 'created',
  };
}

export async function verifyMockPayment(order, pkg) {
  await wait(900);
  return {
    status: 'success',
    paymentId: `pay_${order.packageId}`,
    creditedCoins: pkg.coins + pkg.bonus,
  };
}

export async function startMatchmaking(mode) {
  await wait(900);
  const title = (mode?.title || '').toLowerCase();
  const foundRealPlayer = !title.includes('computer') && !title.includes('bot');

  if (foundRealPlayer) {
    return {
      status: 'matched',
      roomId: `room_${Date.now()}`,
      opponent: 'Aarav_99',
      queueEta: '8 sec',
      source: 'real-player',
    };
  }

  return {
    status: 'bot',
    roomId: `bot_${Date.now()}`,
    opponent: 'LudoBot Alpha',
    queueEta: 'Instant',
    source: 'bot-fallback',
  };
}

export async function fetchAdminOverview() {
  await wait(400);
  return {
    stats: [
      { label: 'Active Users', value: '25,482' },
      { label: 'Live Matches', value: '1,284' },
      { label: 'Bot Ratio', value: '58%' },
      { label: 'Revenue Today', value: '₹48,220' },
    ],
    controls: [
      ['Bot win ratio', 'Balanced • 58%'],
      ['New user protection', 'Enabled'],
      ['Quick entry fee', '100 Coins'],
      ['Classic entry fee', '200 Coins'],
      ['Coin package max', '2500 Coins'],
    ],
  };
}
